import React from "react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative bg-[#030303] border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-20 pb-10">
        {/* Big closing slogan */}
        <div className="py-10 md:py-20 border-b border-white/10">
          <p className="overline mb-6 text-neutral-400">Nasze hasło</p>
          <h3
            data-testid="footer-slogan"
            className="section-title text-white text-5xl sm:text-6xl md:text-7xl lg:text-[7.5rem] leading-[0.95]"
          >
            <span className="italic font-light text-neutral-300">Kamień</span>,
            <br />
            który przetrwa
            <br />
            pokolenia.
          </h3>
        </div>

        <div className="grid md:grid-cols-12 gap-10 py-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="w-9 h-9 border border-white/40 flex items-center justify-center font-serif-display">
                M
              </span>
              <span className="font-serif-display text-xl">Kamieniarstwo Mrozek</span>
            </div>
            <p className="text-neutral-400 text-sm max-w-md leading-relaxed">
              Rodzinny zakład kamieniarski. Nagrobki, schody, parapety, blaty i elementy
              architektury kamiennej. Granit · Marmur · Konglomeraty.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-4">Kontakt</p>
            <ul className="space-y-2 text-sm text-neutral-300">
              <li>+48 607 562 129</li>
              <li>+48 726 747 752</li>
              <li className="break-all">kamieniarstwopaczkow@gmail.com</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="overline mb-4">Adres</p>
            <ul className="space-y-2 text-sm text-neutral-300">
              <li>Chałupki 1</li>
              <li>57-220 Ziębice</li>
              <li className="text-neutral-500 mt-2">Paczków, Dworcowa 10</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="overline mb-4">Godziny</p>
            <ul className="space-y-2 text-sm text-neutral-300">
              <li>pon – pt</li>
              <li>7:00 – 16:00</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-wrap justify-between gap-4 text-[11px] uppercase tracking-[0.25em] text-neutral-500">
          <p>© {new Date().getFullYear()} Kamieniarstwo Mrozek. Wszelkie prawa zastrzeżone.</p>
          <a
            data-testid="footer-admin-link"
            href="/admin/login"
            className="text-neutral-600 hover:text-neutral-300 transition-colors"
          >
            Panel administratora
          </a>
        </div>
      </div>
    </footer>
  );
}
